import { apiClient } from "../apiClient";

export const BO_MON_API = "bo-mon";
export const boMonApi = {
    SelectAll: () => apiClient.get(`${BO_MON_API}`),
}